/**
 * What kind of preview a file gets. Pure functions — no React.
 *
 * Byte and date formatting live with the file dialogs
 * (`components/files/file-dialog/format.ts`); this module only holds the
 * viewer's own decisions, so the two never grow parallel copies.
 */
import { mimeToFileKind } from '@/lib/vault-file-kinds';

export function isImageMime(mime: string | null | undefined): boolean {
  return mimeToFileKind(mime) === 'image';
}

export type PreviewType = 'image' | 'video' | 'audio' | 'pdf' | 'text' | 'unsupported';

export function previewTypeFor(mime: string | null | undefined): PreviewType {
  if (!mime) return 'unsupported';
  if (mime.startsWith('image/')) return 'image';
  if (mime.startsWith('video/')) return 'video';
  if (mime.startsWith('audio/')) return 'audio';
  if (mime === 'application/pdf') return 'pdf';
  if (
    mime.startsWith('text/') ||
    mime === 'application/json' ||
    mime === 'application/xml' ||
    mime === 'application/javascript'
  ) {
    return 'text';
  }
  return 'unsupported';
}
